import {environment} from 'environments/environment';

let lastTimestamps = []

export function timestampChecker(tableId) {
  const timestamp = lastTimestamps.find((timestamp) => timestamp.table_id === tableId)
  return timestamp ? `/** ${timestamp.last_modified_time} **/` : ''
}

async function retrieveTimestampsQuery() {
  const query = `
    SELECT table_id, last_modified_time
    FROM \`${environment.carto.tablePrefix}.__TABLES__\`
  `

  try {
    const url = environment.carto.apiBaseUrl + environment.carto.sqlEndpoint

    const urlWithParams = addQueryParams(url, {
      q: query,
    });

    const body = {
        headers: {
            'Authorization': 'Bearer ' + environment.carto.accessToken,
            'Cache-Control': 'no-cache',
        },
    }

    const response = await fetch(urlWithParams, body)
    const toJson = await response.json()

    if (toJson && toJson.rows) {
      lastTimestamps = toJson.rows
    }
  } catch (err) {
      console.error(`Error fetching sql data: ${err}`)
      return ''
  }
}

retrieveTimestampsQuery()

setInterval(() => {
  retrieveTimestampsQuery()
}, 120000)

// Aux
function addQueryParams(url, queryParams) {
  const queryString = Object.keys(queryParams)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
    .join('&');
  
  return `${url}${url.includes('?') ? '&' : '?'}${queryString}`;
}



// WEBPACK FOOTER //
// ./src/app/cities/informo/layers/timestampChecker.ts